/* eslint-disable lines-between-class-members */
import Route from 'mewe/routes/route';
import PagesApi from 'mewe/api/pages-api';
import { inject as service } from '@ember/service';

export default class ModerationRoute extends Route {
  @service features;
  @service router;

  beforeModel() {
    if (!this.features.isEnabled('pageModeration')) {
      this.router.transitionTo('app.publicid.settings');
    }
  }

  async model() {
    const { pageId } = this.modelFor('app.publicid');
    const response = await PagesApi.getSettings(pageId);
    const model = {
      pageId,
      isAutoModerationOn: Boolean(response?.autoModeration),
      autoModerationLevel: response?.autoModerationLevel,
    };

    if (response?.autoModeration) {
      const { count } = await PagesApi.getModerationCommentsCount(pageId, response.autoModerationLevel);
      model.count = count;
    }

    return model;
  }
}
